export class Position2D {
    x: number
    y: number
}